import React from 'react';

function Detail(props) {
    const {song,isFullScreen,isMobile,handleOpenFullScreenPlayerMobile} = props

    return (
        <div className={`
                            ${(isFullScreen && isMobile) && '!basis-auto w-full'} basis-1/4 
                            ${isFullScreen && 'flex justify-center items-center'} 
                            ${isFullScreen && 'w-full'}
                        `}
             onClick={handleOpenFullScreenPlayerMobile}
        >
            <div className={`
                    flex flex-row items-center
                    ${isFullScreen && '!flex-col'} 
                `}>
                <img src={song.image} alt={song.name}
                     className={`
                         ${isFullScreen && '!w-[150px] !h-[150px] !ml-0 mb-4'} 
                         md:w-[70px] md:h-[70px] w-[50px] h-[50px] rounded-full ml-2
                         `}
                />
                <div className={`
                        flex flex-col text-xs md:text-sm space-y-1 md:space-y-2
                        ${isFullScreen && 'text-center'}
                        `}>
                    <div className="font-medium">{song.name}</div>
                    <div>{song.artistName}</div>
                    {/*{loading ? <div className="loading-indicator">در حال بارگذاری...</div> : null}*/}
                </div>
            </div>
        </div>
    );
}

export default Detail;